export default __webpack_public_path__ + "static/media/anthro.da00cc2d.png";